import { render } from "./Logs.vue?vue&type=template&id=7358f64b&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=7358f64b&scoped=true&lang=css"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7358f64b"]])

export default __exports__